module.exports = __webpack_public_path__ + "img/Product01.98a7c0a1.png";